<div class="mt-8">
	<uc-load-more-btn
		[page]="page()"
		[isLoading]="isLoading()"
		[searchTerm]="searchTerm() || ''"
		(loadMore)="onLoadMore()"
	/>
</div>
<uc-seo-pagination
	ngSkipHydration
	[hasMorePages]="hasMorePages"
	[link]="'/universities/' + product()"
	[queryParams]="queryParams()"
/>
